<template>
	<div class="wrapper-status">
		<div class="center mb-4">
			<img :src="img" alt="imagen" height="68">
		</div>
		<p class="center">
			<span class="text-green">TU PAGO</span>
			<span>{{textOne}}</span>
			<span class="text-green">{{textTwo}}</span>
		</p>
	</div>
</template>
<script>
export default {
	name: 'status',
	props: {
		img: String,
		textOne: String,
		textTwo: String,
	},
};
</script>
<style lang="scss" scoped>
	.center {
		text-align: center;
	}

	.wrapper-status {
		color: map-get($colors, form-grey);
		font-weight: map-get($weight, w900);
		font-size: 25px;
		padding: 85px 0;
	}

	.text-green {
		color: map-get($colors, title-green);
		font-size: 28px;
	}
</style>


// WEBPACK FOOTER //
// src/components/pago/status.vue